import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ChartModule } from 'primeng/chart';

import { ChartComponent } from '@components/_FORKED/chart/chart.component';

@Component({
  selector: 'app-concentration-general-overview',
  standalone: true,
  imports: [ChartModule, ChartComponent],
  template: `
    <div class="card-border col-span-full flex w-full flex-col gap-4 p-6">
      <div class="flex flex-col gap-2">
        <h4 class="font-bold">
          {{ concentration().title.toLocaleUpperCase() }}
        </h4>
        <small class="text-xs text-muted">
          {{ concentration().subtitle }}
        </small>
      </div>
      <div class="flex">
        <chart
          class="grow overflow-auto"
          canvasClasses="rounded-2xl"
          [type]="concentration().type"
          [data]="concentration().data"
          [options]="concentration().options"
          height="375px" />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConcentrationGeneralOverviewComponent {
  concentration: any = input(undefined);
}
